import { render, staticRenderFns } from "./UpdateDiamond.vue?vue&type=template&id=636f481a&scoped=true"
import script from "./UpdateDiamond.vue?vue&type=script&lang=js"
export * from "./UpdateDiamond.vue?vue&type=script&lang=js"
import style0 from "./UpdateDiamond.vue?vue&type=style&index=0&id=636f481a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f481a",
  null
  
)

export default component.exports